var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAssetmanagement105 = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 105,
  height: 105,
  viewBox: "0 0 105 105",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Icons/105/Asset Management"
}, /*#__PURE__*/React.createElement("path", {
  id: "Union",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M61.8071 27.1053C62.0251 27.2749 62.0643 27.589 61.8948 27.807L47.8948 45.807C47.7301 46.0187 47.4277 46.0628 47.2095 45.9069L33.6856 36.247L28.1623 47.2936L47.4801 57.9184L61.2296 49.0794C61.4619 48.9301 61.7713 48.9973 61.9206 49.2296C62.0699 49.4619 62.0027 49.7713 61.7704 49.9206L47.7704 58.9206C47.6161 59.0198 47.4198 59.0265 47.259 58.9381L27.3716 48H19.5C19.2239 48 19 47.7761 19 47.5C19 47.2239 19.2239 47 19.5 47H27.1911L33.0529 35.2764C33.1183 35.1456 33.2377 35.05 33.3796 35.0148C33.5215 34.9795 33.6717 35.0082 33.7907 35.0932L47.4001 44.8142L61.1054 27.1931C61.275 26.9751 61.5891 26.9358 61.8071 27.1053ZM24.7237 53.0529C24.9707 53.1764 25.0708 53.4767 24.9473 53.7237L19.9473 63.7237C19.8238 63.9707 19.5235 64.0708 19.2765 63.9473C19.0295 63.8238 18.9294 63.5235 19.0529 63.2765L24.0529 53.2765C24.1764 53.0295 24.4767 52.9294 24.7237 53.0529Z",
  fill: "var(--icon-decorative-coral)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Union_2",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13 44.5C13 27.103 27.103 13 44.5 13C61.897 13 76 27.103 76 44.5C76 61.897 61.897 76 44.5 76C27.103 76 13 61.897 13 44.5ZM44.5 12C26.5507 12 12 26.5507 12 44.5C12 62.4493 26.5507 77 44.5 77C53.295 77 61.2741 73.5064 67.1252 67.8313L92.1474 92.8535C92.3426 93.0487 92.6592 93.0487 92.8545 92.8535C93.0497 92.6582 93.0497 92.3416 92.8545 92.1464L67.8323 67.1242C73.5068 61.2732 77 53.2945 77 44.5C77 26.5507 62.4493 12 44.5 12Z",
  fill: "currentColor"
}))));
export default SvgAssetmanagement105;